function Loading() {
  return (
    <div className="bg-indigo-500 rounded-md flex justify-center text-white w-36 h-10 items-center mx-auto">
      {/* <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        className="mx-2 animate-spin"
      >
        <path
          d="M15 7.99999C15 9.54609 14.4881 11.0487 13.5443 12.2733C12.6004 13.4978 11.2777 14.3755 9.78261 14.7692C8.28749 15.1629 6.70407 15.0506 5.27952 14.4497C3.85496 13.8488 2.66941 12.7932 1.90791 11.4477C1.14642 10.1021 0.851826 8.5423 1.07011 7.01169C1.2884 5.48108 2.00729 4.0658 3.11457 2.98675C4.22185 1.9077 5.65522 1.2256 7.19095 1.04691"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg> */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 37 36"
        fill="none"
        className="mx-2 animate-spin"
      >
        <circle cx="18.5" cy="18" r="15.5" stroke="grey" strokeWidth="5" />
        <path
          d="M18.5 2.36356C18.5 1.0582 19.5627 -0.0159655 20.8568 0.154954C23.3465 0.483773 25.7489 1.33123 27.905 2.65248C30.7354 4.38696 33.031 6.87038 34.5381 9.82817C36.0452 12.786 36.705 16.1029 36.4445 19.4123C36.2461 21.9332 35.5196 24.3749 34.3223 26.5823C33.6999 27.7298 32.2062 27.9581 31.1501 27.1909C30.0941 26.4236 29.8821 24.9514 30.4501 23.7761C31.1649 22.2973 31.602 20.6924 31.732 19.0414C31.924 16.6011 31.4375 14.1553 30.3262 11.9742C29.2149 9.79322 27.5222 7.96199 25.4351 6.68301C24.023 5.81769 22.4676 5.22796 20.8511 4.93702C19.5664 4.70578 18.5 3.66892 18.5 2.36356Z"
          fill="white"
        />
      </svg>
      Loading...
    </div>
  );
}

export default Loading;

export function RouterLoading() {
  return (
    <div className="bg-indigo-500 rounded-md flex justify-center text-white w-36 h-10 items-center mx-auto">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 37 36"
        fill="none"
        className="mx-2 animate-spin"
      >
        <circle cx="18.5" cy="18" r="15.5" stroke="grey" strokeWidth="5" />
        <path
          d="M18.5 2.36356C18.5 1.0582 19.5627 -0.0159655 20.8568 0.154954C23.3465 0.483773 25.7489 1.33123 27.905 2.65248C30.7354 4.38696 33.031 6.87038 34.5381 9.82817C36.0452 12.786 36.705 16.1029 36.4445 19.4123C36.2461 21.9332 35.5196 24.3749 34.3223 26.5823C33.6999 27.7298 32.2062 27.9581 31.1501 27.1909C30.0941 26.4236 29.8821 24.9514 30.4501 23.7761C31.1649 22.2973 31.602 20.6924 31.732 19.0414C31.924 16.6011 31.4375 14.1553 30.3262 11.9742C29.2149 9.79322 27.5222 7.96199 25.4351 6.68301C24.023 5.81769 22.4676 5.22796 20.8511 4.93702C19.5664 4.70578 18.5 3.66892 18.5 2.36356Z"
          fill="white"
        />
      </svg>
      路由加载中...
    </div>
  );
}
